import { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import Sidebar from '@rio-cloud/rio-uikit/lib/es/Sidebar';

import { SidebarTitleAsset } from '@/components/Asset';
import { SidebarLoader } from '@/components/SidebarLoader';
import { useAppDispatch, useAppSelector } from '@/configuration/setup/hooks';
import { AppContext } from '@/features/app/layout/AppContext';
import { VehicleWarningsMfe } from '@/features/microfrontends/VehicleWarningsMfe';
import { closeVehicleWarningsSidebar, getVehicleWarningsSidebarIsOpen } from '@/features/vehicleWarnings/slice/vehicleWarningsSidebarSlice';
import { Asset } from '@/generated/fleetAggregationServiceTypes';

type VehicleWarningsSidebarProps = {
    testMode?: boolean;
    asset: Asset;
};

const VehicleWarningsSidebar = ({ testMode = false, asset }: VehicleWarningsSidebarProps) => {
    const dispatch = useAppDispatch();
    const isOpen = useAppSelector(getVehicleWarningsSidebarIsOpen);
    const { sidebarRef } = useContext(AppContext);

    if (!isOpen) {
        return null;
    }

    const handleClose = () => {
        dispatch(closeVehicleWarningsSidebar());
    };

    const renderSidebar = () => (
        <Sidebar
            fly
            width={600}
            title={
                <>
                    <span className="display-flex align-items-center gap-5">
                        <FormattedMessage id="intl-msg:fleetstatus.vehicleWarnings.sidebar.title" />
                        <span className="label label-filled label-condensed text-uppercase text-size-10 text-medium bg-warmup-raspberry border-none">
                            <FormattedMessage id="intl-msg:fleetstatus.vehicleWarnings.sidebar.preview" />
                        </span>
                    </span>
                    <SidebarTitleAsset asset={asset} />
                </>
            }
            showHeaderBorder
            titleClassName="padding-left-10"
            onClose={handleClose}
            footer={
                <div className="display-flex padding-left-10">
                    <button className="btn btn-default" type="button" onClick={handleClose}>
                        <span className="rioglyph rioglyph-chevron-left margin-right-5" />
                        <FormattedMessage id="intl-msg:fleetstatus.global.back" />
                    </button>
                </div>
            }
        >
            <div className="padding-left-20 padding-right-20">
                <VehicleWarningsMfe assetId={asset.id} expanded />
            </div>
        </Sidebar>
    );

    return <SidebarLoader testMode={testMode} sidebarRef={sidebarRef} renderSidebar={renderSidebar} sidebarItemId={asset.id} />;
};

export default VehicleWarningsSidebar;
